import { Injectable } from '@angular/core';
import {IPredicate} from './model/predicate.interface';
import {ICondition} from './model/condition.interface';
import {HttpService} from '../auth/http.client.service';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';
import {RequestOptions, Response, URLSearchParams} from '@angular/http';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {Constants} from './constants';
import {IActionConfiguration} from './model/action.configuration.interface';
import {Router} from '@angular/router';
import {RuleModel} from './model/RuleModel';
import {NucleusInputChannelModel} from './model/nucleus.input.channel.model';;
import {Observable, Subject, Subscription} from '../../../node_modules/rxjs';
import {NotificationType} from '../core/notify';
import {NotificationBarService} from '../core/notify/notification.service';
@Injectable()
export class RulesService {
  private  thingsURI = `${environment.serviceBase}/accounts/:accountId/things`;
  private  ruleUri = `${environment.serviceBase}/accounts/:accountId/rules`;
  private thingSubject = new ReplaySubject(1);
  private thingList = [];
  private actionList: Array<IActionConfiguration> = [];
  private parentThing: any;
  private ruleModel: RuleModel;
  private editColumnSubject: Subject<boolean> = new Subject<boolean>();
  rows = [];
  constructor(private httpService: HttpService,
              private authService: AuthService,
              private notifier: NotificationBarService,
              private router: Router) {
    }

  setConditionRows(predicate: IPredicate) {
    this.rows = [];
    this.reSetParentThing();
    if (!predicate) {
      this.rows.push(this.getRowInitialData());
      return;
    }
    this.rows = this.ruleToVisualModel(predicate);
    this.parentThing = this.getThing(this.rows[0].conditions[0].condition.attributeParent);
  }

  resetSavedThings() {
    this.thingList = [];
  }

  getThingListSubject() {
    return this.thingSubject.asObservable();
  }

  getRule(id) {
    const uri = this.httpService.buildPath(this.ruleUri, {accountId: this.authService.getCurrentAccount().id});
    return this.httpService.get(`${uri}/${id}`)
      .map(response => response.json().data)
      .catch(this.handleError);
  }

  deleteRule(id) {
    const uri = this.httpService.buildPath(this.ruleUri, {accountId: this.authService.getCurrentAccount().id});
    return this.httpService.delete(`${uri}/${id}`)
      .map(res => res.json().data)
      .catch(this.handleError);
  }
  getRuleList(page, pageSize) {
    page = page ? page : 1;
    pageSize = pageSize ? pageSize : 10;
    const uri = this.httpService.buildPath(this.ruleUri, {accountId: this.authService.getCurrentAccount().id});
    let search = this.setParams({page: page, 'page-size': pageSize});
    let options = new RequestOptions({ search: search });
    return this.httpService.get(uri, options)
      .map(response => response.json().data)
      .catch(this.handleError);
  }

  navigateToEditRule(rule: RuleModel) {
    this.setRule(rule);
    this.router.navigate([`/rules/${rule.id}/edit/step-2`]);
  }

  setRule(rule: RuleModel) {
    this.ruleModel = rule;
  }
  reSetParentThing() {
    this.parentThing = null;
  }
  getParentThing() {
     return this.parentThing;
  }

   setActionList(actionList: Array<IActionConfiguration>) {
    for (let action of actionList) {
      this.saveAction(action);
    }
  }
  addThingToList(thing): void {
    if (!this.parentThing) {
      this.parentThing = thing;
    }
    if (!thing || this.getThing(thing.token)) {
      return;
    }
    this.thingList.push(thing);
  }

  getThing(token) {
    return this.thingList.find((item) => item.token === token);
  }

  getSavedThings() {
    return this.thingList ? this.thingList : [];
  }

   updateRule(name, description) {
    this.ruleModel.name = name;
    this.ruleModel.description = description;
     const uri = this.httpService.buildPath(this.ruleUri, {accountId: this.authService.getCurrentAccount().id});
     return this.httpService.put(`${uri}/${this.ruleModel.id}`, this.ruleModel)
       .map(response => response.json().data)
       .catch(this.handleError);
   }
  deleteColumn(rowIndex, columnIndex) {
    this.rows[rowIndex].conditions.splice(columnIndex, 1);
    if (this.isRowToBeRemoved(rowIndex)) {
      this.deleteRow(rowIndex);
    }
    if (this.rows.length === 1) {
      this.parentThing = null;
    }
  }

  saveAction(action: IActionConfiguration): void {
    const actionNames = this.actionList.map(item => item.name);
    let index = actionNames.indexOf(action.name);
    if (index < 0) {
      this.actionList.push(action);
    } else {
      this.actionList[index] = action;
    }
  }

  saveCondition(columnData, columnIndex, rowIndex) {
    columnData.isNew = false;
    columnData.isEditMode = false;
    this.rows[rowIndex].conditions[columnIndex] = columnData ;
    this.addMoreCondition(rowIndex, columnIndex);
    this.addMoreRows(rowIndex);
  }

  getActionList(): Array<IActionConfiguration> {
    return this.actionList;
  }

  getThingList(page: number, pageSize: number) {
    const uri = this.httpService.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    let search = this.setParams({page: page, 'page-size': pageSize, 'schema-details': true});
    let options = new RequestOptions({ search: search });
    this.httpService.get(uri, options)
      .map(response => response.json().data.items)
      .subscribe(things => this.thingSubject.next(things) );
  }

  getConfiguredActions(): Array<IActionConfiguration> {
    return this.actionList;
  }

  resetActionList() {
    this.actionList = [];
  }

  getItem(fullyQualifiedAttributeName, attributeParentId) {
    const thing = this.getThing(attributeParentId);
    if (!thing) {
      return null;
    }
    const properties = this.splitNameByDot(fullyQualifiedAttributeName);
    if (properties.length !== 2) {
      return null;
    }
    return this.getAttribute(properties[0], properties[1], thing);
  }

  getPreLabel(fullyQualifiedAttributeName) {
    if (!fullyQualifiedAttributeName) {
      return null;
    }
    return this.splitNameByDot(fullyQualifiedAttributeName)[0];
  }

  isValid(step): boolean {
    switch (step) {
      case Constants.STEP_ONE:
        return this.hasAtLeastOneCondition();
    }
    return false;
  }

  goToNextAction() {
    const param = this.ruleModel.id ? this.ruleModel.id : 'new';
    this.router.navigate([`rules/${param}/step-5`]);
  }

  goToPreviousAction() {
    const param = this.ruleModel.id ? this.ruleModel.id : 'new';
    this.router.navigate([`rules/${param}/step-3`]);
  }

  toRuleModel () {
    let infix = '';
    if (!this.rows || !this.rows.length) {
      return ;
    }
    if (!this.ruleModel) {
      this.ruleModel = new RuleModel();
    }
    this.ruleModel.predicate.conditions = [];
    this.ruleModel.predicate.infix = null;
    let nucleusChannel = new NucleusInputChannelModel();
    const rowLength = this.rows.length - 1;
    this.rows.forEach((row, index) => {
      if (!row.conditions[0] || !row.conditions[0].condition.attributeParent) {
        return;
      }
      const columnLength = row.conditions.length - 1;
      if (columnLength !== 1 && rowLength >= 1) {
        infix += Constants.OPENING_BRACE;
      }
      row.conditions.forEach((columnData, columnIndex) => {
        if (!columnData.condition.attributeParent) {
          return;
        }
        infix += Constants.PLACEHOLDER_LABEL;
        this.ruleModel.predicate.conditions.push(columnData.condition);
        if (columnLength !== columnIndex + 1) {
          infix += columnData.logicalConnector;
        }
      });
      if (columnLength !== 1 && rowLength >= 1) {
        infix += Constants.CLOSING_BRACE;
      }
      if (index + 1 !== rowLength) {
        infix += row.logicalConnector;
      }
    });
    nucleusChannel.configuration.thing = this.ruleModel.predicate.conditions[0].attributeParent;
    this.ruleModel.inputChannel = nucleusChannel;
    this.ruleModel.actions = this.actionList;
    if (this.ruleModel.predicate.conditions.length > 1) {
      this.ruleModel.predicate.infix = infix;
    }
  }

  getRuleModel(): RuleModel {
    return this.ruleModel;
  }

  saveRule(name: string, description?: string) {
    if (!name) {
      return;
    }
    this.ruleModel.name = name;
    this.ruleModel.description = description;
    const uri = this.httpService.buildPath(this.ruleUri, {accountId: this.authService.getCurrentAccount().id});
    return this.httpService.post(uri, this.ruleModel)
      .map(response => response.json().data)
      .catch(this.handleError);
  }

  getThingDetails(thingId: number): Observable<any> {
    let uri = this.httpService.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id, id: thingId});
    return this.httpService.get(`${uri}/${thingId}`)
      .map(this.saveThing)
      .catch(this.handleError);
  }

  navigateToDetails(rule) {
    this.setRule(rule);
    this.router.navigate([`/rules/${rule.id}`]);
  }

   hasMoreThanOneCondition(): boolean {
    return this.rows.length > 1 || this.rows[0].conditions.length > 1;
   }

   hasExactOneCondition(): boolean {
    return this.rows[0].conditions.length === 2 && this.rows.length === 2 && this.rows[1].conditions.length === 1;
   }

   resetAllEditMode() {
    this.rows.forEach(row => {
      if (!row.conditions) {
        return;
      }
      row.conditions.forEach(column => {
        column.isEditMode = false;
      });
    });
   }

   getEditColumnSubscription(): Observable<boolean> {
    return this.editColumnSubject.asObservable();
   }

   notifyEditColumn() {
    this.editColumnSubject.next(true);
   }

  private saveThing = (response: Response) => {
    const thing  = response.json().data;
    this.addThingToList(thing);
  }
  private ruleToVisualModel(predicate: IPredicate) {
    if (!predicate || !predicate.conditions.length) {
      return;
    }
    let operatorArray = [];
    if (predicate.infix) {
      operatorArray = predicate.infix.split('');
    }
    operatorArray = operatorArray.filter((item) => item !== '%' && item !== 's');
    let operands = predicate.conditions, isLookingForClosingBracket = false;
    let rows = [], row = {conditions: [], logicalConnector: null}, conditionIndex = 0, columnData;
    for (let i = 0, infixLength = operatorArray.length; i <= infixLength; i++) {
      if (operatorArray[i] === Constants.OPENING_BRACE) {
        row = {conditions: [], logicalConnector: null};
        isLookingForClosingBracket = true;
        continue;
      }
      if (operatorArray[i] === Constants.CLOSING_BRACE) {
        columnData = this.getColumnData(operands[conditionIndex]);
        columnData.logicalConnector = Constants.LOGICAL_AND;
        row.conditions.push(columnData);
        row.conditions.push(this.getColumnInitialData());
        row.logicalConnector = operatorArray[i + 1];
        rows.push(row);
        row = {conditions: [], logicalConnector: null};
        conditionIndex++;
        i++;
        isLookingForClosingBracket = false;
        continue;
      }
      columnData = this.getColumnData(operands[conditionIndex], operatorArray[i]);
      row.conditions.push(columnData);
      conditionIndex++;
      if (i === infixLength - 1) {
        row.logicalConnector = operatorArray[i];
      }
      if (!isLookingForClosingBracket) {
        row.conditions.push(this.getColumnInitialData());
        row.logicalConnector = operatorArray[i];
        rows.push(row);
        row = {conditions: [], logicalConnector: null};
      }
    }
    rows[rows.length - 1].logicalConnector = Constants.LOGICAL_OR;
    rows.push(this.getRowInitialData());
    return rows;
  }
  private hasAtLeastOneCondition() {
    return this.rows[0].conditions.length > 1;
  }

  private  splitNameByDot(name) {
    return name.split(Constants.DOT);
  }

  private getAttribute(property, attributeName, thing) {
    return thing.schema[property].find(item => item.name === attributeName);
  }

  private deleteRow(rowIndex): void {
    this.rows.splice(rowIndex, 1);
  }

  private isRowToBeRemoved(rowIndex): boolean {
    return this.rows[rowIndex].conditions.length === 1 && this.rows.length > 1;
  }

  private getColumnData(condition: ICondition, logicalConnector?: string) {
    let columnData = this.getColumnInitialData();
    let connector = logicalConnector ? logicalConnector : Constants.LOGICAL_AND;
    columnData.condition = condition;
    columnData.isNew = false;
    columnData.isEditMode = false;
    columnData.logicalConnector = connector;
    return columnData;
  }

  private getColumnInitialData() {
    let condition: ICondition = {
      attributeParent: null,
      attributeName: null,
      operator: null,
      constraint: {
        referenceId: null,
        value: null
      }
    };
    return {condition, isNew: true, isEditMode: false, logicalConnector: Constants.LOGICAL_AND};
  }

  private getRowInitialData() {
    let conditions = [];
    let row = {conditions, logicalConnector: null};
    conditions.push(this.getColumnInitialData());
    return row;
  }

  private addMoreCondition(rowIndex, columnIndex) {
    if (this.rows[rowIndex].conditions.length === columnIndex + 1) {
      this.rows[rowIndex].conditions.push(this.getColumnInitialData());
    }
  }

  private addMoreRows(rowIndex) {
    if (this.rows.length === rowIndex + 1) {
      this.rows.push(this.getRowInitialData());
      this.rows[rowIndex].logicalConnector = Constants.LOGICAL_OR;
    }
  }


  private setParams = (args) => {
    let params: URLSearchParams = new URLSearchParams();
    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        params.set(key, args[key]);
      }
    }

    return params;
  }

  private handleError =  (error: Response | any) => {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status ? body.status.message : body;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    this.notifier.create({message: errMsg, type: NotificationType.Error});
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/rules.service.ts